const SET_ERROR = '[login]set.error';
const CLEAR_ERROR = '[login]clear.error';

export {
	SET_ERROR,
	CLEAR_ERROR
}